import React from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {ensureLeadingZero} from '~/shared/components/QuoteWidget/utils';
import {Button, Link, Stack} from '@customink/pigment-react';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export function QuoteWithoutDesign(props) {
  return (
    <Notification {...props} title="You’re missing the best part!">
      <p className="ndx-cta1" style={{marginTop: '0.25rem'}}>
        This product cannot be purchased blank.
      </p>
      <Stack className="notification-stack">
        <Button
          size="large"
          variant="secondary"
          className="notification-cta"
          onClick={props.dismiss}>
          Back To Designing
        </Button>
        <p className="ndx-cta1">
          <span style={{margin: '0.25rem 0'}}>Not ready to design?</span>
          <Link
            href={`/quotes/?product_id=${ensureLeadingZero(
              props.currentColorId
            )}`}
            rel="noopener noreferrer"
            target="_blank">
            <br />
            Use our Quick Quote tool
          </Link>
        </p>
      </Stack>
    </Notification>
  );
}

const propTypes = {
  currentColorId: PropTypes.string,
  dismiss: PropTypes.func
};

QuoteWithoutDesign.propTypes = propTypes;

QuoteWithoutDesign.displayName = 'QuoteWithoutDesign';

import {createStructuredSelector} from 'reselect';
import {getCurrentColorId} from '~/selectors/ProductSelectors';

function select() {
  return createStructuredSelector({
    currentColorId: getCurrentColorId
  });
}

import {connect} from 'react-redux';

export default connect(select, null)(QuoteWithoutDesign);
